import { useTranslation } from "react-i18next";
import { Box, Divider, IconButton, Typography } from "@mui/material";

import { GoHireGoalngoLogoIcon, HeaderBackArrowIcon } from "../assets/icons/go-hire-page-icons";

const CreateJobHeader = ({ handleGoBack }: { handleGoBack: (prevStep: number) => void }) => {
  const { t, i18n } = useTranslation("goHire", { keyPrefix: "createJobPage" });
  const handleBack = () => handleGoBack(1);

  return (
    <Box sx={styles.container}>
      <Box sx={styles.headerContainer}>
        <Box sx={styles.headerLeftContainer}>
          <IconButton sx={styles.backButton} onClick={handleBack}>
            <HeaderBackArrowIcon />
          </IconButton>
          <GoHireGoalngoLogoIcon />
        </Box>
        <Divider flexItem orientation="vertical" />
        <Typography component="h2" sx={styles.headerTitle}>
          {t("createANewJob")}
        </Typography>
      </Box>
    </Box>
  );
};

export default CreateJobHeader;

const styles = {
  container: {
    padding: "20px 0",
    borderBottom: "1px solid var(--Gray---100, #E7E7E7)",
    background: "var(--White, #FFF)",
  },
  headerContainer: {
    display: "flex",
    gap: "24px",
    alignItems: "center",
    maxWidth: "1140px",
    width: "80%",
    margin: "0 auto",
  },
  headerLeftContainer: {
    display: "flex",
    alignItems: "center",
    gap: "40px",
  },
  backButton: {
    borderRadius: "8px",
    border: "1px solid var(--Gray-300, #D0D5DD)",
    boxShadow: "0 1px 2px 0 rgba(16, 24, 40, 0.05)",
  },
  headerTitle: {
    color: "var(--Dark---1000, #111)",
    fontFamily: "Montserrat",
    fontSize: "24px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "32px",
  },
};
